import { INativeFilterBuilder } from '@/shared/filters/native-filter-builder.interfaces';
import {
  FilterOperatorEnum,
  StringFilterInput,
} from '@/shared/types/types.generated';

export class StringFilterBuilder implements INativeFilterBuilder<StringFilterInput> {
  private filter: Partial<StringFilterInput> = {};

  eq(value?: string) {
    if (value?.trim()) this.filter.eq = value.trim();
    return this;
  }

  contains(value?: string) {
    if (value?.trim()) this.filter.contains = value.trim();
    return this;
  }

  beginsWith(value?: string) {
    if (value?.trim()) this.filter.beginsWith = value.trim();
    return this;
  }

  ne(value?: string) {
    if (value?.trim()) this.filter.ne = value.trim();
    return this;
  }

  notContains(value?: string) {
    if (value?.trim()) this.filter.notContains = value.trim();
    return this;
  }

  in(values?: string[]) {
    if (values?.length) this.filter.in_ = values;
    return this;
  }

  doNotIgnoreNullable(values?: FilterOperatorEnum[]) {
    if (values) this.filter.doNotIgnoreNullable = values;
    return this;
  }

  containsAny(values?: string[]) {
    if (values?.length) this.filter.containsAny = values;
    return this;
  }

  between(values?: string[]) {
    if (values?.length) this.filter.between = values;
    return this;
  }

  reset() {
    return undefined;
  }

  build() {
    return Object.keys(this.filter).length ? this.filter : undefined;
  }
}
